import { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { MockVideoCard } from './video-card'
import { MockFilter } from './filter'
import { mockVideos } from '../../services/data'
import { setPreviewLan, setPreview } from '../../store/reducers/general'
import { MockHeader } from './header'
import { MockSideBar } from './side-bar'
import { updateStyleToTheme } from '../../services/theme.js'

export const Preview = () => {
    const dispatch = useDispatch()
    const [filter, setFilter] = useState('')
    const [sorter, setSorter] = useState('')
    const [search, setSearch] = useState('')
    const { preview } = useSelector(state => state.general)
    const { previewLan } = useSelector(state => state.general)
    const { currentTeam } = useSelector(state => state.user)
    const theme = 'dark'

    useEffect(() => {
        updateStyleToTheme(theme)
    }, [theme])

    const toDisplay = useMemo(() => {
        try {
            let v = preview.map((video) => ({ ...video, channelImage: currentTeam.channelImage, channelName: currentTeam.channelName, image: video.ideaMaker.thumbnails[0], title: video.ideaMaker.titles[0], length: '16:25', views: '451K', from: '1 hour' }))

            if (preview.length === 1) return v.concat(mockVideos)

            if (filter) v = v.filter(video => video.ideaMaker.type === filter)

            if (search) v = v.filter(video => video.ideaMaker.titles.some(title => title.includes(search)))

            if (sorter.includes('מחיר')) v.sort((a, b) => sorter === 'מחיר מהגבוה לנמוך' ? b.producer.totalPrice - a.producer.totalPrice : a.producer.totalPrice - b.producer.totalPrice)
            else v.sort(() => Math.random() - 0.5)

            return v
        }
        catch (err) {
            return []
        }
    }, [preview, filter, sorter, search])

    if (!preview) return <></>

    return <section style={{ direction: previewLan === 'he' ? 'rtl' : 'ltr' }}>
        <MockHeader setSearch={setSearch} search={search} />
        <section className="preview">
            <MockSideBar lan={previewLan} />
            <div className='home' style={{ width: '100%', paddingTop: '0' }}>
                <MockFilter previewLan={previewLan} />
                <div className='videos-wrapper'>
                    {toDisplay.map((video, idx) => <MockVideoCard key={idx} video={video} previewLan={previewLan} preview={preview} isReal={video.ideaMaker} />)}
                </div>
            </div>
        </section>
        <div className='preview-control'>
            <div className='cancel-preview' onClick={() => dispatch(setPreview(false))}><span className="material-symbols-outlined">close</span></div>
            <div className='lan' onClick={() => dispatch(setPreviewLan(previewLan === 'he' ? 'en' : 'he'))}><span className="material-symbols-outlined">language</span></div>
        </div>
    </section>
}

